// 币种定义
export interface Currency {
  code: string;      // 货币代码 (CNY, USD, etc.)
  symbol: string;    // 货币符号 (¥, $, etc.)
  name: string;      // 显示名称
}

export const CURRENCIES: Currency[] = [
  { code: 'CNY', symbol: '¥', name: '人民币（默认）' },
  { code: 'USD', symbol: '$', name: '美元 (USD)' },
  { code: 'EUR', symbol: '€', name: '欧元 (EUR)' },
  { code: 'GBP', symbol: '£', name: '英镑 (GBP)' },
  { code: 'JPY', symbol: '¥', name: '日元 (JPY)' },
  { code: 'HKD', symbol: 'HK$', name: '港币 (HKD)' },
  { code: 'SAR', symbol: 'SAR ', name: '沙特里亚尔 (SAR)' },
  { code: 'SGD', symbol: 'S$', name: '新加坡元 (SGD)' },
  { code: 'THB', symbol: '฿', name: '泰铢 (THB)' },
  { code: 'MYR', symbol: 'RM ', name: '马来西亚林吉特 (MYR)' },
  { code: 'IDR', symbol: 'Rp ', name: '印尼盾 (IDR)' },
  { code: 'VND', symbol: '₫', name: '越南盾 (VND)' },
  { code: 'PHP', symbol: '₱', name: '菲律宾比索 (PHP)' },
  { code: 'OTHER', symbol: '', name: '其他（自定义）' },
];

// 获取默认币种（人民币）
export const DEFAULT_CURRENCY = CURRENCIES[0];

// 根据代码获取币种
export const getCurrencyByCode = (code: string): Currency => {
  return CURRENCIES.find(c => c.code === code) || DEFAULT_CURRENCY;
};

export interface Invoice {
  id: string;
  file: File | null;
  number: string;
  amount: number;
  date: string;
  type: string;
  customType?: string; // 自定义类型的具体内容
  isManual: boolean;
  isDuplicate?: boolean;
  // 出差补贴相关字段
  isAllowance?: boolean; // 是否是出差补贴
  startDate?: string; // 出发日期
  endDate?: string; // 返回日期
  city?: string; // 出差城市
}

export interface ExpenseData {
  userName: string;
  expenseType: 'daily' | 'business' | '';
  projectName: string;
  projectCode: string;
  invoices: Invoice[];
  totalAmount: number;
  // 币种相关
  currencyCode: string;       // 币种代码
  currencySymbol: string;     // 币种符号
  customCurrencyName?: string;   // 自定义币种名称（当选择"其他"时）
  customCurrencySymbol?: string; // 自定义币种符号（当选择"其他"时）
}

export const DAILY_INVOICE_TYPES = [
  '招待费', '餐饮费', '交通费', '停车费', '通讯费', '办公用品',
  '项目配件', '图书', '食品', '快递物流', '维修服务', '物业费',
  '包装费', '培训费', '货运代理', '服装', '打印费', '咨询费',
  '充电服务', '高速通行费', '服务费', '住宿费', '购物卡',
  '投标费用', '核酸检测', '自定义'
];

export const BUSINESS_INVOICE_TYPES = [
  '机票费-普票', '机票费-专票', '机场建设费-普票', '火车票',
  '大巴/出租/船票', '住宿费-普票', '住宿费-专票', '汽车租赁-普票',
  '汽车租赁-专票', '过路费', '加油费', '市内交通', '招待费-普票',
  '招待费-专票', '杂项（无票）', '餐补（无票）', '自定义'
];

// 出差补贴城市标准（元/天）
export const ALLOWANCE_CITY_RATES: Record<string, number> = {
  '北京': 120,
  '上海': 120,
  '广州': 120,
  '深圳': 120,
  '厦门': 100,
  '其它': 80
};

export const ALLOWANCE_CITIES = Object.keys(ALLOWANCE_CITY_RATES);
